/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invites_PendingInputs */

const en_invites_pending = /** @type {(inputs: Invites_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open invites`)
};

const de_invites_pending = /** @type {(inputs: Invites_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offene Einladungen`)
};

/**
* | output |
* | --- |
* | "Open invites" |
*
* @param {Invites_PendingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const invites_pending = /** @type {((inputs?: Invites_PendingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invites_PendingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_invites_pending(inputs)
	return en_invites_pending(inputs)
});